import moment from 'moment';
import Select from 'react-select';

import './shift-item.scss';

import { useIsManager } from '~modules/auth/model';
import { SectionDto } from '~modules/section/model';
import { ShiftTypes } from '~modules/tabel/interfaces/shift-types';
import { WorkTimeTypes } from '~modules/tabel/interfaces/work-time-types';
import { CancelBtn } from '~shared/ui/button/cancel-btn';
import TimeIntervalPicker from '~shared/ui/time-interval-picker/TimeIntervalPicker';

import { ShiftTypeSelect } from '../shift-type-select/shift-type-select';
import { UserSelect } from '../user-select/user-select';
import { WorkTimeTypeSelect } from '../work-time-type-select/work-time-type-select';
import { IShiftItem } from './interface';

interface ShiftItemProps {
	shiftItem: IShiftItem;
	onChange: (data: IShiftItem) => void;
	onDelete: (idx: string) => void;
	sections: SectionDto[];
}

export function ShiftItem({ shiftItem, onChange, onDelete, sections }: ShiftItemProps) {
	const isManager = useIsManager();
	const handleTimeChange = (start: Date | null, end: Date | null) => {
		onChange({ ...shiftItem, scheduledStart: start, scheduledEnd: end });
	};

	const handleChange = (item: IShiftItem) => {
		const obj = sections.length === 1 ? { section_id: sections[0].id } : {};
		onChange({ ...obj, ...item });
	};

	return (
		<>
			<td>
				<ShiftTypeSelect
					defaultValue={shiftItem.shiftType}
					isClearable={false}
					onChange={shiftType => {
						if (shiftType) onChange({ ...shiftItem, shiftType: ShiftTypes[shiftType] });
					}}
				/>
			</td>
			<td>
				<input
					className="date-input"
					type="date"
					style={{ padding: '8px' }}
					value={shiftItem.date ? moment(shiftItem.date).format('YYYY-MM-DD') : ''}
					onChange={e => {
						const date = new Date(e.target.value);
						handleChange({ ...shiftItem, date });
					}}
				/>
			</td>
			<td>
				<TimeIntervalPicker
					calendarDate={shiftItem.date}
					startTime={shiftItem.scheduledStart}
					endTime={shiftItem.scheduledEnd}
					onChange={handleTimeChange}
					placeholder="Выбрать"
				/>
			</td>
			<td>
				<UserSelect
					isMulti
					value={shiftItem.users}
					className="user-container"
					selectClassName="user-select"
					onChange={v => {
						const users = Array.isArray(v) ? v : [v];
						handleChange({ ...shiftItem, users });
					}}
				/>
			</td>
			<td align="center">
				<WorkTimeTypeSelect
					defaultValue={shiftItem.workTimeType}
					isManager={isManager}
					excluded={[
						WorkTimeTypes.UnexcusedAbsences,
						WorkTimeTypes.WeekendsAndHolidays,
						WorkTimeTypes.SickLeave,
						WorkTimeTypes.Dismissed,
						WorkTimeTypes.AnnualPaidLeave,
					]}
					onChange={wtt => {
						if (wtt) handleChange({ ...shiftItem, workTimeType: wtt });
					}}
				/>
			</td>
			<td>
				<Select<SectionDto>
					getOptionLabel={option => `${option.title}`}
					getOptionValue={option => `${option.id}-${option.id}`}
					options={sections}
					value={sections.length === 1 ? sections[0] : undefined}
					isDisabled={sections.length === 1}
					isClearable={true}
					placeholder="Выберите участок"
					onChange={v => v && handleChange({ ...shiftItem, section_id: v.id! })}
				/>
			</td>
			<td>
				<CancelBtn onClick={() => onDelete(shiftItem.idx)} />
			</td>
		</>
	);
}
